import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { getCurrentUser, hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { ActivatedRoute } from '@angular/router';
import {    SimuladorService } from '../services/simulador.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import * as XLSX from 'xlsx';
import { empty } from 'rxjs';

@Component({
    selector: 'app-cargue-archivos',
    templateUrl: './simulador.component.html',
    styleUrls: ['./simulador.component.scss'],
    styles: [
      `
      @media only screen and (max-width: 500px) {
        .card-body {
            flex-wrap: wrap
          }
        }
        `
    ]
  })

export class SimuladorComponent implements OnInit {
  plazos: number[] = []; 
  tnm: number[] = []; 
  cuotas: number[] = []; 
  tasas: number[] = []; 
  seguros: number[] = []; 
  seg: number[] = []; 
  estados: string[] = []; 
  comision: number[] = []; 
  cuota: string[] = [];
  seguro: string[] = [];
  intereses: string[] = []; 
  financiado: string[] = [];
  full: string[] = [];
  simulacion: string[] = []; 
  cobranza: number[] = [];
      public tasaForm = this.formBuilder.group({
        capital: ["", [Validators.required]]
        })
      constructor(private notificationService: NotificationHelper,
        private notificationHelper: NotificationHelper,
        private helpers: HelpersService,
        private simuladorService: SimuladorService,
        private formBuilder: FormBuilder,
      ) {

      }
      async traerTasas(){
        try {
          const usuario = getCurrentUser();
          const empresa = usuario ? usuario.c_emp : 'JA';
          const resp: any = await this.simuladorService.tasas(empresa || 'JA');
          if (Array.isArray(resp)) {
            this.plazos = resp;
          } else {
            console.error("La respuesta no contiene un array de plazos válido.");
            this.plazos = [15, 16, 20, 23, 24, 25, 27, 30, 34, 37, 40, 44];
          }
        } 
        catch (error) {
          this.notificationService.errorMessage("Ocurrió un error desconocido.");
          hideSpinner();
          return;
        }
      }
      async traerTnm(){
        try {
          const usuario = getCurrentUser();
          const empresa = usuario ? usuario.c_emp : 'JA';
          const resp: any = await this.simuladorService.tnm(empresa || 'JA');
          if (Array.isArray(resp)) {
            this.tnm = resp; 
          } else {
            console.error("La respuesta no contiene un array de plazos válido.");
          }
        } 
        catch (error) {
          this.notificationService.errorMessage("Ocurrió un error desconocido.");
          hideSpinner();
          return;
        }
      }
      async traerSeg(){
        try {
          const usuario = getCurrentUser();
          const empresa = usuario ? usuario.c_emp : 'JA';
          const resp: any = await this.simuladorService.seg(empresa || 'JA');
          if (Array.isArray(resp)) {
            this.seg = resp;
          } else {
            console.error("La respuesta no contiene un array de plazos válido.");
          }
        } 
        catch (error) {
          this.notificationService.errorMessage("Ocurrió un error desconocido.");
          hideSpinner();
          return;
        }
      }
      async traerEstado(){
        try {
          const usuario = getCurrentUser();
          const empresa = usuario ? usuario.c_emp : 'JA';
          const resp: any = await this.simuladorService.estado(empresa || 'JA');
          if (Array.isArray(resp)) {
            this.estados = resp; 
          } else {
            console.error("La respuesta no contiene un array de plazos válido.");
          }
        } 
        catch (error) {
          this.notificationService.errorMessage("Ocurrió un error desconocido.");
          hideSpinner();
          return;
        }
      }
      async traerCobranza(){
        try {
          const usuario = getCurrentUser();
          const empresa = usuario ? usuario.c_emp : 'JA';
          const resp: any = await this.simuladorService.cobranza(empresa || 'JA');
            this.cobranza = [resp]; 
        } 
        catch (error) {
          this.notificationService.errorMessage("Ocurrió un error desconocido.");
          hideSpinner();
          return;
        }
      }
      async traerComision(){
        try {
          const usuario = getCurrentUser();
          const empresa = usuario ? usuario.c_emp : 'JA';
          const resp: any = await this.simuladorService.comision(empresa || 'JA');          
          if (Array.isArray(resp)) {
            this.comision = resp; 
          } else {
            console.error("La respuesta no contiene un array de plazos válido.");
          }
        } 
        catch (error) {
          this.notificationService.errorMessage("Ocurrió un error desconocido.");
          hideSpinner();
          return;
        }
      }
      async  guardarTasa(): Promise<void> {
        try {
          showSpinner(`Guardando Registros...`);
          const usuario = getCurrentUser();
          const usuarioId = usuario ? usuario.usuario_aplicativo : 'SADMIN';
          const empresa = usuario ? usuario.c_emp : 'JA';
          const res = await this.simuladorService.ActualizarTasa(empresa || 'JA', this.tnm,usuarioId);
          
          if(!res.success) {
            this.notificationService.errorMessage(res.message);
            hideSpinner();
            return;
          }
          hideSpinner()
          this.notificationService.successMessage("Guardado correctamente")
        } catch (error) {
          console.error(error);
          this.notificationService.errorMessage("Ocurrio un error desconocido.")
          hideSpinner();
          return;
        }
      }
      async  guardarSeguros(): Promise<void> {
        try {
          showSpinner(`Guardando Registros...`);
          const usuario = getCurrentUser();
          const usuarioId = usuario ? usuario.usuario_aplicativo : 'SADMIN';
          const empresa = usuario ? usuario.c_emp : 'JA';
          const res = await this.simuladorService.ActualizarSeguro(empresa || 'JA', this.seg,usuarioId);
          
          if(!res.success) {
            hideSpinner();
            this.notificationService.errorMessage(res.message);
            return;
          }
          hideSpinner()
          this.notificationService.successMessage("Guardado correctamente")
        } catch (error) {
          console.error(error);
          this.notificationService.errorMessage("Ocurrio un error desconocido.")
          hideSpinner();
          return;
        }
      }
      async  guardarEstados(): Promise<void> {
        try {
          showSpinner(`Guardando Registros...`);
          const usuario = getCurrentUser();
          const usuarioId = usuario ? usuario.usuario_aplicativo : 'SADMIN';
          const empresa = usuario ? usuario.c_emp : 'JA';
          const res = await this.simuladorService.ActualizarEstado(empresa || 'JA', this.estados, usuarioId);
          
          if(!res.success) {
        hideSpinner();
        this.notificationService.errorMessage(res.message);
        return;
          }
          hideSpinner()
          this.notificationService.successMessage("Guardado correctamente")
        } catch (error) {
          console.error(error);
          this.notificationService.errorMessage("Ocurrio un error desconocido.")
          hideSpinner();
          return;
        }
      }
      async  guardarComision(): Promise<void> {
        try {
          showSpinner(`Guardando Registros...`);
          const usuario = getCurrentUser();
          const usuarioId = usuario ? usuario.usuario_aplicativo : 'SADMIN';
          const empresa = usuario ? usuario.c_emp : 'JA';
          const res = await this.simuladorService.ActualizarComision(empresa || 'JA', this.comision, usuarioId);
          
          if(!res.success) {
        hideSpinner();
        this.notificationService.errorMessage(res.message);
        return;
          }
          hideSpinner()
          this.notificationService.successMessage("Guardado correctamente")
        } catch (error) {
          console.error(error);
          this.notificationService.errorMessage("Ocurrio un error desconocido.")
          hideSpinner();
          return;
        }
      }
      async  guardarCobranza(): Promise<void> {
        try {
          showSpinner(`Guardando Registros...`);
          const res = await this.simuladorService.ActualizarCobranza('JA', this.cobranza);
          
          if(!res.success) {
        hideSpinner();
        this.notificationService.errorMessage(res.message);
        return;
          }
          hideSpinner()
          this.notificationService.successMessage("Guardado correctamente")
        } catch (error) {
          console.error(error);
          this.notificationService.errorMessage("Ocurrio un error desconocido.")
          hideSpinner();
          return;
        }
      }
      trackByIndex(index: number, item: any): number {
        return index;
    }

      actualizarTasa(event: Event, index: number): void {
        const contenido = (event.target as HTMLElement).textContent?.trim() || ''; 
        const valorNumerico = parseFloat(contenido.replace('%', '').replace(',', '.')); 
        this.tnm[index] = isNaN(valorNumerico) ? 0 : valorNumerico;
      }
      actualizarCobranza(event: Event, index: number): void {
        const contenido = (event.target as HTMLElement).textContent?.trim() || ''; 
        const valorNumerico = parseFloat(contenido.replace('%', '').replace(',', '.')); 
        this.cobranza[index] = isNaN(valorNumerico) ? 0 : valorNumerico;
      }
      actualizarSeguro(event: Event, index: number): void {
        const contenido = (event.target as HTMLElement).textContent?.trim() || ''; // Obtiene el contenido editado
        const valorNumerico = parseFloat(contenido.replace(/[^0-9.]/g, '')); // Extrae solo números y convierte a número
        // Si el valor es NaN, se asigna 0, de lo contrario, actualiza el array
        this.seg[index] = isNaN(valorNumerico) ? 0 : valorNumerico;
    }
    
    
      actualizarEstado(event: Event, index: number): void {
        const contenido = (event.target as HTMLElement).textContent?.trim() || ''; // Obtiene el contenido editado
        this.estados[index] = contenido; // Actualiza el array con el valor limpio
    }
  
    actualizarComision(event: Event, index: number): void {
      const contenido = (event.target as HTMLElement).textContent?.trim() || ''; // Obtiene el contenido editado
      const valorNumerico = parseFloat(contenido.replace(/[^0-9.]/g, '')); // Extrae solo números y convierte a número
      // Si el valor es NaN, se asigna 0, de lo contrario, actualiza el array
      this.comision[index] = isNaN(valorNumerico) ? 0 : valorNumerico;
  }
  
  async onSubmit(): Promise<void> {
    const formValues = this.tasaForm.value;
    if (!this.tasaForm.get("capital")?.valid) {
      return this.notificationHelper.warningMessage("Por favor ingresar el monto");
    }
    showSpinner(`Realizando la simulación...`);
    let capital = formValues.capital;
    try {
      let res;
      try {
        res = await this.simuladorService.Simulador('JA', capital);
        if (!res.success) {
          hideSpinner();
          this.notificationService.errorMessage(res.message);
          return;
        }
        this.simulacion = res.data;
      } catch (error) {
        hideSpinner();
        this.notificationService.errorMessage("Error en la simulación.");
        return;
      }
      
      const [resp, respu, respuesta]: any = await Promise.all([
        this.simuladorService.tasas('JA'),
        this.simuladorService.tnm('JA'),
        this.simuladorService.seg('JA')
      ]);
      
      if (Array.isArray(resp)) {
        this.cuotas = resp;
        this.tasas = respu;
        this.seguros = respuesta;
      } else {
        console.error("La respuesta no contiene un array de plazos válido.");
        this.cuotas = [15, 16, 20, 23, 24, 25, 27, 30, 34, 37, 40, 44];
      }
      res.data.forEach((item, index) => {
        this.cuota[index]=item["Valor Cuota"]
        this.seguro[index]=item["Total Seguro"]
        this.intereses[index]=item["Total Intereses"]
        this.financiado[index]=item["Total financiado"]
        this.full[index]=item["Precio Full"]
      });

      const formatCurrency = (value: number) => `$${value.toLocaleString('es-CO')}`;
      const formatPercentage = (value: number) => `${(value * 1).toFixed(2)}%`;

      let excelData = res.data.map((item, index) => ({
        "No. Cuotas": resp[index] || "N/A",
        "Cuota": formatCurrency(item["Valor Cuota"]),
        "Total Seguro": formatCurrency(item["Total Seguro"]),
        "Total Intereses": formatCurrency(item["Total Intereses"]),
        "Total Financiado": formatCurrency(item["Total financiado"]),
        "Precio Full": formatCurrency(item["Precio Full"]),
        "Tasa": respu[index] ? formatPercentage(respu[index]) : "N/A",
        "Seguro": formatCurrency(respuesta[index])
      }));
  
      if (!res.success) {
        hideSpinner();
        this.notificationService.errorMessage(res.message);
        return;
      }
  
      // Crear y exportar Excel
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Simulación");
      XLSX.writeFile(workbook, "Simulacion.xlsx");
  
      hideSpinner();
      this.notificationService.successMessage("Simulación realizada y descargada correctamente");
    } catch (error) {
      this.notificationService.errorMessage("Ocurrió un error desconocido.");
      hideSpinner();
      return;
    }
  }
    ngOnInit(): void {
      this.traerTasas();
      this.traerTnm();
      this.traerSeg();
      this.traerEstado();
      this.traerCobranza();
      this.traerComision();
    }
}